import { PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

type CardRowProps = PropsWithChildren & {
  size?: "sm" | "default";
};
export const CardRow = ({ children, size = "default" }: CardRowProps) => {
  return (
    <div
      className={cn(
        "flex flex-row items-center justify-between gap-1",
        size === "sm" && "px-0.5 text-xs/[14px]",
        size === "default" && "px-1 text-sm"
      )}
    >
      {children}
    </div>
  );
};
